module.exports = __webpack_public_path__ + "fonts/Lato-Italic.0acac383.eot";